// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H0nVbmRs2c25ePx9wWwh{position:absolute;z-index:10;top:10px;right:10px}.Gk0hknkfz61YxCKbLvTQ{background:#fff;border-radius:100%}`, "",{"version":3,"sources":["webpack://./src/components/cards/defaults/ItemHorizontalCard/components/CardCheckbox/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,UAAA,CACA,QAAA,CACA,UAAA,CACF,sBACE,eAAA,CACA,kBAAA","sourcesContent":[".radio\n  position: absolute\n  z-index: 10\n  top: 10px\n  right: 10px\n.circle\n  background: #fff\n  border-radius: 100%\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radio": `H0nVbmRs2c25ePx9wWwh`,
	"circle": `Gk0hknkfz61YxCKbLvTQ`
};
export default ___CSS_LOADER_EXPORT___;
